import { motion } from "framer-motion";
import { CONTACT } from "../data/content";

export const Contact = () => {
  return (
    <section id="contacto" data-testid="contact-section" className="py-24 md:py-32 bg-[#F4F2F7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-[#2D1B4E] text-white rounded-sm overflow-hidden shadow-xl p-10 md:p-16"
        >
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-overline text-[#C7B8E6] font-semibold mb-5">
              {CONTACT.overline}
            </p>
            <h2 className="font-serif-display text-3xl md:text-5xl font-semibold tracking-tight leading-[1.1]">
              {CONTACT.title}
            </h2>
            <p className="text-white/70 mt-5 text-sm leading-relaxed">
              Comunícate con nosotros para resolver tus dudas sobre admisiones, programas o
              cualquier información institucional.
            </p>
          </div>

          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {CONTACT.details.map((d) => {
              const Icon = d.icon;
              return (
                <div
                  key={d.label}
                  data-testid={`contact-detail-${d.label}`}
                  className="flex items-start gap-4"
                >
                  <span className="flex items-center justify-center w-11 h-11 bg-white/10 rounded-sm shrink-0">
                    <Icon strokeWidth={1.5} className="w-5 h-5 text-[#C7B8E6]" />
                  </span>
                  <div>
                    <p className="text-xs uppercase tracking-overline text-white/50">
                      {d.label}
                    </p>
                    <p className="text-sm mt-1 leading-relaxed">{d.value}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
